import React, { ReactNode, useEffect, useState } from 'react'
import { Toast } from 'react-bootstrap';

export interface ToastProps{
    idx:string;
    theme: 'danger' | 'success' | 'light';
    title?: string;
    body?: ((children?: ReactNode) => ReactNode); 
    autohide?: boolean;
    onCloseEvent?: () => void;
}

const Toaster = ({ theme = 'light', title='Smash', body, autohide = true, onCloseEvent}: ToastProps) => {

    const [show, setShow] = useState(false);

    useEffect(() => {
        setShow(true);
    }, []);

    const handleClose = () => {
        setShow(false);
        if(onCloseEvent) {
            onCloseEvent();            
        }
    }

  return (
    <Toast onClose={() => handleClose()} show={show} delay={3000} autohide={autohide} bg={theme} >
        <Toast.Header>
            <strong className="me-auto">{title}</strong>
            <small>Now</small>
        </Toast.Header>
        {body && <Toast.Body className={theme === 'light' ? 'text-black' : 'text-white'}>
            {body()}
        </Toast.Body>}
    </Toast>
  )
}

export default Toaster